module.exports = __webpack_public_path__ + "static/media/client-logo-23.ed05b616.jpg";